import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import plTranslation from './locales/pl/translation.json';
import ruTranslation from './locales/ru/translation.json';

// Add type declaration for returnNull
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const isBrowser = typeof window !== 'undefined';

/** Bundled locales — avoids stale CDN/cache returning old JSON (missing keys, outdated hero copy). */
const translationResources = {
  en: { translation: enTranslation as Record<string, unknown> },
  pl: { translation: plTranslation as Record<string, unknown> },
  ru: { translation: ruTranslation as Record<string, unknown> },
};

if (!i18n.isInitialized) {
  if (isBrowser) {
    const LanguageDetector = require('i18next-browser-languagedetector').default;
    i18n.use(LanguageDetector);
  }

  i18n
    .use(initReactI18next)
    .init({
      lng: 'pl',
      fallbackLng: 'en',
      supportedLngs: ['en', 'pl', 'ru'],
      resources: translationResources,
      debug: process.env.NODE_ENV === 'development',
      detection: isBrowser
        ? {
            order: ['localStorage'],
            caches: ['localStorage'],
          }
        : undefined,
      ns: ['translation'],
      defaultNS: 'translation',
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
      returnNull: false,
    })
    .catch((error: unknown) => {
      if (process.env.NODE_ENV === 'development') {
        console.error('i18n init error', error);
      }
    });
}

export default i18n; 